import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { LakehouseTableDataset } from 'shell-models-lib';
import { TabularTypeDatasetAdapter, tabularPropertiesCommonAdapts } from './tabular-type.dataset.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(LakehouseTableDataset),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            ...tabularPropertiesCommonAdapts,
            linkedService: '*',
            connectionSettings: __IS_FABRIC_DPE__ ? '*' : undefined,
            typeProperties: {
                table: '*',
                schema: '*'
            }
        }
    }
})
export class LakehouseTableDatasetAdapter extends TabularTypeDatasetAdapter<LakehouseTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: LakehouseTableDataset): Promise<Model.DatasetResource> {
        const resource = await this._toResourceInternal(dataset, Metamodel.modelFor(LakehouseTableDataset).name);
        if (__IS_FABRIC_DPE__&& resource?.properties?.linkedService?.properties?.typeProperties) {
            resource.properties.linkedService.properties.typeProperties.rootFolder = 'Tables';
        }
        return resource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: LakehouseTableDataset): Promise<LakehouseTableDataset> {
        const res = await this._toModelInternal(modelDatasetResource, dataset, LakehouseTableDataset.MODEL);
        res.isV2 = true;
        return res;
    }
}
